import { useCallback, useContext, useEffect, useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import DashboardLayout from 'components/layout/dashboard/DashboardLayout'
import Notification from 'components/notifications/Notification'
import AuthContext from 'contexte/AuthContext'
import { fetchSpIssues } from 'services/structuredProductsServices'
import SpNav from './components/SpNav'
import 'pages/bBook/bBook.css'
import './structuredLayout.css'

// Un seul cadre pour les produits structurés, comme le B-book : la barre d'onglets reste, seul l'écran change
const StructuredLayout = () => {
  const { t } = useTranslation()
  const { user } = useContext(AuthContext)
  const { pathname } = useLocation()
  const [issuesCount, setIssuesCount] = useState(null)

  const refreshIssuesCount = useCallback(async () => {
    try {
      setIssuesCount((await fetchSpIssues({ user })).length)
    } catch (error) {
      setIssuesCount(null)
    }
  }, [user])

  useEffect(() => {
    refreshIssuesCount()
  }, [refreshIssuesCount])

  return (
    <DashboardLayout page={t('pages_name.structured_products')}>
      <div className='b_book_page sp_page'>
        <Notification />
        <div className='b_book_appbar'>
          <SpNav issuesCount={issuesCount} />
        </div>
        <div key={pathname} className='b_book_screen'>
          <Outlet context={{ refreshIssuesCount, setIssuesCount }} />
        </div>
      </div>
    </DashboardLayout>
  )
}

export default StructuredLayout
